<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs6>
          <v-btn @click="back" text class="text_btn">
            <v-icon>keyboard_arrow_left</v-icon>back
          </v-btn>
        </v-flex>
        <v-flex xs6 style="text-align:right;">
          <v-btn @click="d_edit = true" text class="text_btn">
            <v-icon>settings</v-icon>Settings
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <h1>{{ p_name }} / {{ name }}</h1>
      <br />
      <v-layout row wrap>
        <v-flex xs12 sm6 style="margin-bottom:30px;padding-right:10px;">
          <h3>Credentials</h3>
          <p>Please use the following App ID and App Secret to connect from your client application to the schmuckliCloud service.</p>
          <b>App ID</b>
          <CopyField :value="app_id" />
          <br />
          <b>App Secret</b>
          <CopyField :value="app_secret" />
          <v-btn @click="d_regenerate_confirm = true" text class="text_btn">
            <v-icon>refresh</v-icon>Regenerate app secret
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6>
          <h3>Restrictions</h3>
          <p>You can restrict the API access of these app credentials, by defining here the origin and other permissions.</p>
          <h4>Origins</h4>
          <p>Only these URLs can access the backend. If nothing is defined, all origins are allowed.</p>
          <div>
            <v-list style="background:transparent;">
              <v-list-item v-for="origin in origins" :key="origin.id">
                <OriginListItem
                  :app_id="id"
                  @onUpdated="loadRestrictions(id)"
                  @onDeleted="loadRestrictions(id)"
                  :origin="origin"
                />
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-form @submit="addOrigin">
                    <v-layout style="margin:0;" row>
                      <v-flex xs10>
                        <v-text-field
                          v-model="new_origin"
                          label="New origin"
                          placeholder=".yourdomain.com"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-btn text type="submit">
                          <i style="margin-right:5px;" class="fal fa-plus"></i>add
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <h4>Storage permissions</h4>
          <p>Define here the permissions for the storage module.</p>
          <div style="padding-left:10px;">
            <v-switch v-model="permission_storage_insert" @change="onStoragePermissionChanged" label="Insert"></v-switch>
            <v-switch v-model="permission_storage_update" @change="onStoragePermissionChanged" label="Update"></v-switch>
            <v-switch v-model="permission_storage_delete" @change="onStoragePermissionChanged" label="Delete"></v-switch>
            <v-switch v-model="permission_storage_get" @change="onStoragePermissionChanged" label="Get"></v-switch>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog for editing the app -->
    <v-dialog v-model="d_edit" width="500">
      <v-card>
        <v-form @submit="saveEditApp">
          <v-card-title class="headline" primary-title>App properties</v-card-title>

          <v-card-text>
            <v-text-field v-model="f_edit_app_name" ref="edit_app_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              text
              class="text_btn"
              @click="d_delete_app = true"
              type="button"
              :loading="l_edit_save"
            >Delete</v-btn>
            <v-btn color="primary" text class="text_btn" type="submit" :loading="l_edit_save">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for regenerate app secret -->
    <v-dialog v-model="d_regenerate_confirm" width="500">
      <v-card>
        <v-form @submit="saveEditApp">
          <v-card-title class="headline" primary-title>Regenerate app secret</v-card-title>

          <v-card-text>
            <p>Are you sure to regenerate the app secret? This will make all clients, who are using the current credetials immediately invalid.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="default"
              text
              class="text_btn"
              @click="d_regenerate_confirm = false"
            >Cancel</v-btn>
            <v-btn
              color="error"
              text
              class="text_btn"
              @click="d_regenerate_confirm = false;regenerateAppSecret()"
              type="button"
              :loading="l_edit_save"
            >Regenerate</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog when trying to delete the app -->
    <v-dialog v-model="d_delete_app" width="500">
      <v-card>
        <v-form>
          <v-card-title class="headline" primary-title>Delete app</v-card-title>

          <v-card-text>
            <p>You are about to delete this app. An application which is associated with the app id and secret can no longer access the schmuckliCloud services. Are you sure?</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="text_btn"
              @click="d_delete_app = false"
              type="button"
            >Cancel</v-btn>
            <v-btn color="red" text class="text_btn" @click="deleteApp" type="button">Delete</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Apps } from "../logic/Apps";
import { Projects } from "../logic/Projects";
import { Notifications } from "../notification";
import CopyField from "../components/general/CopyField";
import OriginListItem from "../components/project/OriginListItem";

export default {
  name: "AppDetail",
  data() {
    return {
      p_name: "...",
      id: 0,
      name: "",
      app_id: "",
      app_secret: "",

      //Dialogs
      d_edit: false,
      d_delete_app: false,
      d_regenerate_confirm: false,

      //Forms
      f_edit_app_name: "",

      //Restrictions
      origins: [],
      new_origin: "",

      permission_storage_insert: false,
      permission_storage_update: false,
      permission_storage_delete: false,
      permission_storage_get: false,
    };
  },
  mounted() {
    this.id = parseInt(this.$route.params.id);
    let project_id = this.$route.params.project_id;

    this.loadProjectMeta(project_id);
    this.loadAppMeta(this.id);
    this.loadRestrictions(this.id);
    this.loadStoragePermissions();
  },
  methods: {
    async loadProjectMeta(project_id) {
      var project_response = await Projects.get(project_id);
      if (project_response.status === 200) {
        if (Array.isArray(project_response.body) && project_response.body.length > 0) {
          this.p_name = project_response.body[0].name;
        } else if (project_response.body && project_response.body.name) {
          this.p_name = project_response.body.name;
        }
      }
    },
    async loadAppMeta(id) {
      var response = await Apps.get(id);
      if (response.status === 200) {
        this.name = response.body.name;
        this.app_id = response.body.app_key;
        this.app_secret = response.body.app_secret;

        this.f_edit_app_name = response.body.name;
        this.setTitle("App: " + this.name);
      } else {
        Notifications.show(response.message);
      }
    },
    async loadRestrictions(app_id) {
      var response = await Apps.loadOrigins(app_id);
      if (response.status === 200) {
        this.origins = response.body || [];
      }
    },
    async addOrigin(e) {
      e.preventDefault();

      var response = await Apps.assignOrigin(this.id, this.new_origin);
      if (response.status === 200) {
        Notifications.show("The origin has been saved.");
        this.new_origin = "";
        this.loadRestrictions(this.id);
      } else {
        Notifications.show(response.message);
      }
    },
    async onStoragePermissionChanged() {
      var response = await Apps.setStoragePermissions(
        this.id,
        this.permission_storage_insert,
        this.permission_storage_update,
        this.permission_storage_delete,
        this.permission_storage_get
      );
      if (response.status === 200) {
        Notifications.show("The storage permissions have been saved.");
      } else {
        Notifications.show(response.message);
      }
    },
    async loadStoragePermissions() {
      var response = await Apps.getStoragePermissions(0, this.id);
      if (response.status === 200) {
        var data = response.body;
        this.permission_storage_insert = data.insert;
        this.permission_storage_update = data.update;
        this.permission_storage_delete = data.delete;
        this.permission_storage_get = data.get;
      } else {
        Notifications.show(response.message);
      }
    },
    saveEditApp(e) {
      e.preventDefault();

      var id = parseInt(this.$route.params.id);

      var global_this = this;

      Apps.edit(id, this.f_edit_app_name).then(function (response) {
        if (response.status === 200) {
          Notifications.show(response.message);
          global_this.name = global_this.f_edit_app_name;
          global_this.d_edit = false;
        } else {
          Notifications.show(response.message);
        }
      });
    },
    async deleteApp() {
      var id = parseInt(this.$route.params.id);
      var project_id = parseInt(this.$route.params.project_id);

      var response = await Apps.delete(id);
      if (response.status === 200) {
        Notifications.show(response.message);
        this.$router.replace("/project/" + project_id);
      } else {
        Notifications.show(response.message);
      }
    },
    async regenerateAppSecret() {
      var id = parseInt(this.$route.params.id);

      var response = await Apps.regenerate(id);
      if (response.status === 200) {
        Notifications.show(response.message);
        this.app_secret = response.body.app_secret;
      } else {
        Notifications.show(response.message);
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
  components: {
    CopyField,
    OriginListItem,
  },
};
</script>
